import modalStyle from "./material-kit-pro-react/modalStyle.jsx";
const manageSessionStyle = theme => ({
    ...modalStyle(theme),
    justifyContentCenter: {
        justifyContent: "space-between"
    }
});

export default manageSessionStyle;
